import { promotionCodeFormStyles as styles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPromotionCode";

styles.applyButton = {
    ...styles.applyButton,
    variant: "secondary",
};
